{
  "GENERAL_PURE_BLACK": "#000000",
  "GENERAL_BG_DARK": "#201830",
  "GENERAL_BG_LIGHT": "#F6F6F6",
  "GENERAL_WHITE": "#FFFFFF",
  "TEXT_ICONS_HEADLINES": "#262626",
  "TEXT_ICONS_PRIMARY": "#595959",
  "TEXT_ICONS_MARGINAL": "#8C8C8C",
  "TEXT_ICONS_PLACEHOLDERS": "#BFBFBF",
  "ACTION_BIG_HEART_PRIMARY": "#4211A0",
  "ACTION_BIG_HEART_PRIMARY_HOVER_80": "#6841B3",
  "ACTION_BIG_HEART_SECONDARY_6": "#F4F1F9",
  "ACTION_BIG_HEART_SECONDARY_HOVER_10": "#EBE6F5",
  "ACTION_MOD_PRIMARY": "#0D00BF",
  "ACTION_MOD_PRIMARY_HOVER_80": "#3D33CC",
  "ACTION_MOD_SECONDARY_6": "#F1F0FB",
  "ACTION_MOD_SECONDARY_HOVER_10": "#E6E5F8",
  "ACTION_BWHI_PRIMARY": "#AC2376",
  "ACTION_BWHI_PRIMARY_HOVER_80": "#BD4F91",
  "ACTION_BWHI_SECONDARY_6": "#FAF2F7",
  "ACTION_BWHI_SECONDARY_HOVER_10": "#F6E9F1",
  "ACTION_MOFEC_PRIMARY": "#2E3094",
  "ACTION_MOFEC_PRIMARY_HOVER_80": "#5859A9",
  "ACTION_MOFEC_SECONDARY_6": "#F3F3F9",
  "ACTION_MOFEC_SECONDARY_HOVER_10": "#EAEAF4",
  "ACTION_CCMP_PRIMARY": "#48196F",
  "ACTION_CCMP_PRIMARY_HOVER_80": "#8D56A7",
  "ACTION_CCMP_SECONDARY_6": "#F7F3F9",
  "ACTION_CCMP_SECONDARY_HOVER_10": "#F0E9F4",
  "ACTION_BRIGHT_STAR_PRIMARY": "#003B5C",
  "ACTION_BRIGHT_STAR_PRIMARY_HOVER_80": "#33627D",
  "ACTION_BRIGHT_STAR_SECONDARY_6": "#F0F4F6",
  "ACTION_BRIGHT_STAR_SECONDARY_HOVER_10": "#E5EBEE",
  "ACTION_CBA_PRIMARY": "#00539B",
  "ACTION_CBA_PRIMARY_HOVER_80": "#3375AF",
  "ACTION_CBA_SECONDARY_6": "#F0F5F9",
  "ACTION_CBA_SECONDARY_HOVER_10": "#E5EDF5",
  "ACTION_COGIC_PRIMARY": "#E0AC1D",
  "ACTION_COGIC_PRIMARY_HOVER_80": "#E6BD4A",
  "ACTION_COGIC_SECONDARY_6": "#FDFAF2",
  "ACTION_COGIC_SECONDARY_HOVER_10": "#FBF6E8",
  "ACTION_COGIC_2_PRIMARY": "#333466",
  "ACTION_COGIC_2_PRIMARY_HOVER_80": "#5C5D85",
  "ACTION_COGIC_2_SECONDARY_6": "#F3F3F6",
  "ACTION_COGIC_2_SECONDARY_HOVER_10": "#EAEAEF",
  "ACTION_DISABLED_TEXTS": "#B8B8B8",
  "ACTION_DISABLED_BACKGROUND": "#F5F5F5",
  "ELEMENTS_BORDERS_DIVIDERS": "#E8E8E8",
  "ELEMENTS_BORDER_BUTTON_DEFAULT": "#D9D9D9",
  "ELEMENTS_TABLE_HEADER": "#FAFAFA",
  "ELEMENTS_LINK_DEFAULT": "#0576DE",
  "ELEMENTS_LINK_VISITED": "#551A8B",
  "ELEMENTS_OTHER_LIKES": "#F5222D",
  "ELEMENTS_OTHER_RATINGS": "#FACA22",
  "ALERT_SUCCESS_PRIMARY": "#509E2A",
  "ALERT_SUCCESS_SECONDARY_10": "#EBFEE0",
  "ALERT_SUCCESS_SECONDARY_HOVER": "#D7FEC1",
  "ALERT_WARNING_PRIMARY": "#D96812",
  "ALERT_WARNING_SECONDARY_10": "#FFECD5",
  "ALERT_WARNING_SECONDARY_HOVER": "#FFE1BE",
  "ALERT_ERROR_PRIMARY": "#EA0B16",
  "ALERT_ERROR_PRIMARY_HOVER_80": "#EE3B45",
  "ALERT_ERROR_SECONDARY_10": "#FFE3E3",
  "ALERT_ERROR_SECONDARY_HOVER_15": "#FCDADC",
  "ALERT_INFO_PRIMARY": "#006AFF",
  "ALERT_INFO_SECONDARY_10": "#E5F0FF",
  "ALERT_INFO_SECONDARY_HOVER": "#C2DCFF",
  "TAGS_BLUE_PRIMARY": "#002766",
  "TAGS_BLUE_SECONDARY": "#E6F7FF",
  "TAGS_BLUE_SECONDARY_HOVER": "#BAE7FF",
  "TAGS_CYAN_PRIMARY": "#002329",
  "TAGS_CYAN_SECONDARY": "#E6FFFB",
  "TAGS_CYAN_SECONDARY_HOVER": "#B5F5EC",
  "TAGS_GREEN_PRIMARY": "#092B00",
  "TAGS_GREEN_SECONDARY": "#F6FFED",
  "TAGS_GREEN_SECONDARY_HOVER": "#D9F7BE",
  "TAGS_GREY_PRIMARY": "#030852",
  "TAGS_GREY_SECONDARY": "#F0F5FF",
  "TAGS_GREY_SECONDARY_HOVER": "#D6E4FF",
  "TAGS_ORANGE_DARK_PRIMARY": "#610B00",
  "TAGS_ORANGE_DARK_SECONDARY": "#FFF2E8",
  "TAGS_ORANGE_DARK_SECONDARY_HOVER": "#FFD8BF",
  "TAGS_ORANGE_MEDIUM_PRIMARY": "#E5400C",
  "TAGS_ORANGE_MEDIUM_SECONDARY": "#FCECE7",
  "TAGS_ORANGE_MEDIUM_SECONDARY_HOVER": "#FAD9CE",
  "TAGS_ORANGE_LIGHT_PRIMARY": "#DF7402",
  "TAGS_ORANGE_LIGHT_SECONDARY": "#FCF1E6",
  "TAGS_ORANGE_LIGHT_SECONDARY_HOVER": "#F7DCC1",
  "TAGS_PINK_PRIMARY": "#520339",
  "TAGS_PINK_SECONDARY": "#FFF0F6",
  "TAGS_PINK_SECONDARY_HOVER": "#FFD6E7",
  "TAGS_PURPLE_PRIMARY": "#120338",
  "TAGS_PURPLE_SECONDARY": "#F9F0FF",
  "TAGS_PURPLE_SECONDARY_HOVER": "#EFDBFF",
  "TAGS_YELLOW_PRIMARY": "#FADB14",
  "TAGS_YELLOW_SECONDARY": "#FEFBE7",
  "TAGS_YELLOW_SECONDARY_HOVER": "#FBF3BB",
  "INPUT_DISABLED_BACKGROUND": "#F7F7F7"
}

